// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__eE9Ss","type":"styles_type__xGXOZ","choices":"styles_choices__37NjC"};